import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=df209a5e&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df209a5e')) {
      api.createRecord('df209a5e', component.options)
    } else {
      api.reload('df209a5e', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=df209a5e&", function () {
      api.rerender('df209a5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/Button.vue"
export default component.exports